{
  "timeScoreBase": 100000,
  "crashPenaltySeconds": 3,
  "cleanMultiplier": { "none": 1, "scrapes": 1.25, "clean": 1.5 },
  "drift": {
    "minSlipAngleDeg": 12,
    "minSpeedKmh": 30,
    "chainLinkSeconds": 1.5,
    "chainBankSeconds": 1.5,
    "maxMultiplier": 5
  }
}
